import { render, staticRenderFns } from "./IconSvgCalendarStar.vue?vue&type=template&id=635bfdde&scoped=true&"
import script from "./IconSvgCalendarStar.vue?vue&type=script&lang=js&"
export * from "./IconSvgCalendarStar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635bfdde",
  null
  
)

export default component.exports